<mat-accordion>
  <mat-expansion-panel class="expansion-panel" [expanded]="true">

    <mat-expansion-panel-header class="custom-header">
      <mat-panel-title>
        Cadastrar Ausência temporária
      </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-progress-bar *ngIf="usersLoading" class="progress-bar" mode="indeterminate"></mat-progress-bar>
    <form [formGroup]="frmAusencia">
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="25%">
          <mat-select #responsavelSelected [disabled]='bloquearResponsavel' [formControl]="frmFiltroResponsavel" [(ngModel)]="responsavel.nome" placeholder="RESPONSÁVEL" required>
            <mat-select-filter *ngIf="responsavelSelected.focused" [placeholder]="'Pesquisar...'" [array]="optionsResponsavel" (filteredReturn)="filteredResponsavel=$event" required></mat-select-filter>
            <mat-option *ngFor="let resp of filteredResponsavel" [value]="resp">
              {{ resp }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="f.frmFiltroResponsavel.errors && f.frmFiltroResponsavel.errors.required">Selecione um responsável
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="frmDtInicial" [matDatepickerFilter]="filterDataInicio" (click)="picker.open()" [(ngModel)]="cadastroAusencia.dataInicio" [matDatepicker]="picker" placeholder="DATA INICIAL" readonly>
          <span matSuffix class="calendar">
            <mat-icon (click)="picker.open()">calendar_today</mat-icon>
          </span>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="f.frmDtInicial.errors && f.frmDtInicial.errors.required">A data inicial é obrigatória
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput formControlName="frmDtFinal" [matDatepickerFilter]="filterDataFim" (click)="picker1.open()" [(ngModel)]="cadastroAusencia.dataFim" [matDatepicker]="picker1" placeholder="DATA FINAL" readonly>
          <span matSuffix class="calendar">
            <mat-icon (click)="picker1.open()">calendar_today</mat-icon>
          </span>
          <mat-datepicker #picker1></mat-datepicker>
          <mat-error *ngIf="f.frmDtFinal.errors && f.frmDtFinal.errors.required">A data final é obrigatória</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="25%">
          <mat-select #novoResponsavelSelected [formControl]="frmFiltroUser" [(ngModel)]="novoResponsavel.nome" placeholder="NOVO RESPONSÁVEL" required>
            <mat-select-filter *ngIf="novoResponsavelSelected.focused" [placeholder]="'Pesquisar...'" [array]="optionsNovoResponsavel" (filteredReturn)="filteredNovoResponsavel=$event" required></mat-select-filter>
            <mat-option *ngFor="let novoResp of filteredNovoResponsavel" [value]="novoResp">
              {{ novoResp }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="f.frmFiltroUser.errors && f.frmFiltroUser.errors.required">Selecione um usuário</mat-error>
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <section class="slide-toggle" fxFlex="25%">
          <mat-slide-toggle formControlName="frmDelegarPerfil" name="slideDelegarPerfil" [checked]="delegarPerfil" (change)="onChangeDelegarPerfil()">DELEGAR PERFIL</mat-slide-toggle>
        </section>
        <div>
          <button mat-button color="primary" [disabled]="formularioIsValid()" class="btn-primary" (click)="cadastrarAusencia()" (keyup.enter)="cadastrarAusencia()">SALVAR</button>
        </div>
      </div>
    </form>
    <br />
    <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
      <div style="padding: 0px !important;">
        <div style="padding-left: 80%">
          <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
          </mat-form-field>
        </div>
        <div class="table-container">
          <table mat-table [dataSource]="dataSource">

            <ng-container matColumnDef="loginUsuario">
              <th mat-header-cell *matHeaderCellDef> Usuário </th>
              <td mat-cell *matCellDef="let element"> {{element.loginUsuario}} </td>
            </ng-container>
            <ng-container matColumnDef="loginUsuarioRecebedor">
              <th mat-header-cell *matHeaderCellDef> Usuário Designado </th>
              <td mat-cell *matCellDef="let element"> {{element.loginUsuarioRecebedor}} </td>
            </ng-container>
            <ng-container matColumnDef="dataInicio">
              <th mat-header-cell *matHeaderCellDef> Data Início </th>
              <td mat-cell *matCellDef="let element"> {{element.dataInicio | date: 'dd/MM/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="dataFim">
              <th mat-header-cell *matHeaderCellDef> Data Fim </th>
              <td mat-cell *matCellDef="let element"> {{element.dataFim | date: 'dd/MM/yyyy'}} </td>
            </ng-container>
            <ng-container matColumnDef="delegarPerfil">
              <th mat-header-cell *matHeaderCellDef> Delegar Perfil </th>
              <td mat-cell *matCellDef="let element"> {{element.delegarPerfil ? 'Sim' : 'Não' }} </td>
            </ng-container>
            <ng-container matColumnDef="ativo">
              <th mat-header-cell *matHeaderCellDef> Ativo </th>
              <td mat-cell *matCellDef="let element"> {{element.ativo ? 'Sim' : 'Não'}} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>Ações</th>
              <td mat-cell *matCellDef="let element">
                <button [disabled]="desabilitarExclusao(element)" mat-icon-button (click)="excluir(element)" color="primary">
                <mat-icon class="mat-18">delete</mat-icon>
              </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>